import React from "react";
import { Link } from "react-router-dom";

export const ElmMark = ({ className = "w-8 h-8", light = false }) => (
  <img
    src={light ? "/assets/elm-icon-white.png" : "/assets/elm-icon-navy.png"}
    alt=""
    aria-hidden="true"
    className={`${className} object-contain`}
  />
);

export const Logo = ({ variant = "light" }) => {
  const primary = variant === "light" ? "text-white" : "text-[#0A2B3D]";
  const secondary = variant === "light" ? "text-[#A9CFE2]" : "text-[#2E86C1]";
  return (
    <Link to="/" data-testid="logo-home-link" className="flex items-center gap-3 group">
      <img
        src={variant === "light" ? "/assets/elm-icon-white.png" : "/assets/elm-icon-navy.png"}
        alt="American Elm Advisors logo"
        className="w-9 h-10 object-contain transition-transform duration-500 group-hover:scale-105"
      />
      <span className="leading-none">
        <span className={`block font-serif font-bold text-lg tracking-wide ${primary}`}>American Elm</span>
        <span className={`block font-mono text-[10px] uppercase tracking-[0.42em] mt-1 ${secondary}`}>Advisors</span>
      </span>
    </Link>
  );
};
